<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM16.5 5.92 8.5 2v18h-2v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06Z"
    />
  </svg>
</template>
